export function customOrderQuestionsWithDependsOn(questions) {
    const questionsCopy = [...questions];
    questionsCopy.sort((a, b) => {
        if (a.displayOrder !== b.displayOrder) {
            return a.displayOrder - b.displayOrder;
        }
        if (a?.props?.dependsOn?.[0]?.field === (b.title.en || b.title.fr)) return 1;
        if (b?.props?.dependsOn?.[0]?.field === (a.title.en || a.title.fr)) return -1;
        return 0;
    });
    return questionsCopy;
}